/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_VisitsInputs */

const en_admin_funnel_history_visits = /** @type {(inputs: Admin_Funnel_History_VisitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visits (est.)`)
};

/**
* | output |
* | --- |
* | "Visits (est.)" |
*
* @param {Admin_Funnel_History_VisitsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_visits = /** @type {((inputs?: Admin_Funnel_History_VisitsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_VisitsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_visits(inputs)
});
export { admin_funnel_history_visits as "admin.funnel.history.visits" }